import {
	BeneficiaryGroupUser,
	GroupUser,
	OrgGroups,
	Permission,
} from '../models/groups.model';

export interface GroupsState {
	beneOnlyUsers: BeneficiaryGroupUser[];
	groupPermissions: Permission[];
	groupUsers: GroupUser[];
	groups: OrgGroups[];
	loading: boolean;
	permissions: Permission[];
	users: GroupUser[];
}

export const initialState: GroupsState = {
	beneOnlyUsers: [],
	groupPermissions: [],
	groupUsers: [],
	groups: [],
	loading: false,
	permissions: [],
	users: [],
};
